var Curriculog = Curriculog || {};

Curriculog.UserPermissionsView = (function ($, _, Backbone, UserPermissionsView) {

    UserPermissionsView = Curriculog.CurriculogView.extend({
        template: 'HierarchyFlyout/userPermissions.html',
        events: {
        },

        initialize: function (options) {
            this.permissions = options.permissions;
            this.render();
        },

        render: function () {
            this.el = nunjucks.render(this.template, this.permissions);
            this.replaceElement(this.el);
        },
    });
    return UserPermissionsView;

})($, _, Backbone, Curriculog.UserPermissionsView || {});
